import { useEffect, useState } from "react";

// Convite pra instalar o app na tela do celular.
// Android/Chrome: o navegador avisa quando dá pra instalar (beforeinstallprompt)
// e a instalação é um toque. iPhone: a Apple não expõe esse evento, então
// mostramos o passo a passo do "Compartilhar > Adicionar à Tela de Início".
const CHAVE_DISPENSADO = "help-instalar-dispensado";

function ehIOS() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
}

function jaInstalado() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

export default function BotaoInstalar() {
  const [convite, setConvite] = useState(null);
  const [mostrar, setMostrar] = useState(false);
  const [passoIOS, setPassoIOS] = useState(false);

  useEffect(() => {
    if (jaInstalado() || localStorage.getItem(CHAVE_DISPENSADO) === "sim") return;

    function aoPoderInstalar(e) {
      e.preventDefault();
      setConvite(e);
      setMostrar(true);
    }
    window.addEventListener("beforeinstallprompt", aoPoderInstalar);

    // iPhone nunca dispara o evento: mostra o convite mesmo assim
    if (ehIOS()) setMostrar(true);

    return () => window.removeEventListener("beforeinstallprompt", aoPoderInstalar);
  }, []);

  function instalar() {
    if (ehIOS() && !convite) {
      setPassoIOS(true);
      return;
    }
    if (!convite) return;
    convite.prompt();
    convite.userChoice.finally(() => {
      setConvite(null);
      setMostrar(false);
    });
  }

  function dispensar() {
    localStorage.setItem(CHAVE_DISPENSADO, "sim");
    setMostrar(false);
    setPassoIOS(false);
  }

  if (!mostrar) return null;

  const barra = {
    position: "fixed",
    left: 12,
    right: 12,
    bottom: 12,
    zIndex: 1200,
    background: "#132436",
    border: "1px solid #d4af37",
    borderRadius: 14,
    padding: "14px 16px",
    boxShadow: "0 8px 28px rgba(0,0,0,.45)",
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
  };

  if (passoIOS) {
    return (
      <div style={barra} className="nao-imprimir">
        <div style={{ flex: "1 1 100%" }}>
          <p style={{ color: "#d4af37", fontWeight: 700, margin: "0 0 8px", fontSize: "0.95rem" }}>
            <i className="bi bi-phone"></i> Instalar no iPhone
          </p>
          <ol style={{ color: "#e8eef5", fontSize: "0.85rem", margin: 0, paddingLeft: 18, lineHeight: 1.7 }}>
            <li>
              Toque em <strong>Compartilhar</strong> <i className="bi bi-box-arrow-up"></i> (embaixo do navegador)
            </li>
            <li>
              Escolha <strong>Adicionar à Tela de Início</strong>
            </li>
            <li>
              Confirme em <strong>Adicionar</strong>
            </li>
          </ol>
        </div>
        <button className="btn btn-outline-he" style={{ flex: 1, minHeight: 44 }} onClick={dispensar}>
          Entendi
        </button>
      </div>
    );
  }

  return (
    <div style={barra} className="nao-imprimir">
      <div style={{ flex: "1 1 150px", minWidth: 0 }}>
        <p style={{ color: "#d4af37", fontWeight: 700, margin: 0, fontSize: "0.95rem" }}>
          <i className="bi bi-download"></i> Instalar o app
        </p>
        <p style={{ color: "#9aa5b5", fontSize: "0.78rem", margin: "2px 0 0" }}>
          Abre direto da tela do celular, sem navegador
        </p>
      </div>
      <div style={{ display: "flex", gap: 8, flex: "1 1 100%" }}>
        <button className="btn btn-he" style={{ flex: 2, minHeight: 44, fontWeight: 700 }} onClick={instalar}>
          Instalar agora
        </button>
        <button className="btn btn-outline-he" style={{ flex: 1, minHeight: 44 }} onClick={dispensar}>
          Agora não
        </button>
      </div>
    </div>
  );
}
